import { useState } from "react"

import { SidebarProvider } from "@/components/ui/sidebar"
import { getStoredValue, setStoredValue } from "@/lib/safe-storage"
import { cn } from "@/lib/utils"

interface AppShellProps extends React.ComponentProps<"div"> {
  children: React.ReactNode
  variant?: "header" | "sidebar"
  className?: string
}

export function AppShell({ children, variant = "header", className, ...props }: AppShellProps) {
  const [isOpen, setIsOpen] = useState(() =>
    getStoredValue("sidebar") !== "false",
  )

  const handleSidebarChange = (open: boolean) => {
    setIsOpen(open)

    setStoredValue("sidebar", String(open))
  }

  if (variant === "header") {
    return <div className="flex min-h-screen w-full flex-col">{children}</div>
  }

  return (
    <SidebarProvider
      defaultOpen={isOpen}
      open={isOpen}
      onOpenChange={handleSidebarChange}
      className={cn(className)}
      {...props}
    >
      {children}
    </SidebarProvider>
  )
}
